const mainvar = spedizioniweb2;
const logger = mainvar.LOGGER;

const useBSSLogger = () => {
    return {logger};
}

export default useBSSLogger;